import { render, staticRenderFns } from "./IconEnglish.vue?vue&type=template&id=38af89b0&"
import script from "./IconEnglish.vue?vue&type=script&lang=ts&"
export * from "./IconEnglish.vue?vue&type=script&lang=ts&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports